import { render, staticRenderFns } from "./notification-menu.vue?vue&type=template&id=a750b64c&lang=pug&"
import script from "./notification-menu.vue?vue&type=script&lang=ts&"
export * from "./notification-menu.vue?vue&type=script&lang=ts&"
import style0 from "./notification-menu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports